import React, { useState, useEffect } from "react"

import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import SweetAlert from "react-bootstrap-sweetalert"
import { CheckPermission } from "../Permissions/CheckPermissions"
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

const Payments = (props) => {

  const sortOptions = [
    { id: 1, value: "enabled", label: "Enabled" },
    { id: 2, value: "all", label: "All" }
  ]

  const [data, setData] = useState([])
  const [sortBy, setSortBy] = useState(sortOptions[0].value)
  const [token, setToken] = useState('')
  const [success_msg, setsuccess_msg] = useState(false)
  const [errorMessage, SetErrorMessage] = useState('')
  const [errorMsgAlert, setErrorMsgAlert] = useState(false)
  const [del, setDelete] = useState(false)
  const [ItemForDelete, setItemForDelete] = useState('initialState')

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken")
    setToken(token)
    getPaymentMethods(token)
  }, [sortBy, success_msg])

  useEffect(() => {
    // autoDisableBanners(data, token)

    return (() => { })
  }, [setData, token, errorMessage])


  const handleConfirmation = () => {

    return (

      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          deleteEntry(ItemForDelete?.item_id, token)
          setDelete(false)
          // props?.history.push(`/carousel-banners/estore`)
          // setsuccess_msg(false)
        }}
        onCancel={() => setDelete(false)}
        show={true}>
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    )
  };

  const getPaymentMethods = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=paymentmethods&env=production`, requestOptions)
      .then(response => response.json())
      .then(result => {
        let tempData = []
        if (result) {
            console.log("Checking payment methods", result)
          result?.paymentMethods?.map((item) => {
              tempData = [...tempData, item]
          })
          /*Sorting according to postion and date */
          tempData.sort((a, b) => {
            if (a.sort_order == b.sort_order) {
              return (Date.parse(b.published_at) - Date.parse(a.published_at))
            }
            else {
              return a.sort_order - b.sort_order;
            }
          })
          // autoDisableBanners(tempData, token)
          setData(tempData)
        }
      })
      .catch(error => console.log('error', error));
  }
  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=paymentmethods/delete&id=${ID}`, requestOptions)
      .then(response => {
        if (response.status == 200) {
          setsuccess_msg(true)
        } else {
          setErrorMsgAlert(true)
        }
        response.text()
      })
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

  }
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          setsuccess_msg(false)
          // props.props?.history.push("/campaigns")
        }}
        onCancel={() => {
          setsuccess_msg(false)
        }}
      >
        {"Payment Method deleted successfully."}
      </SweetAlert>
    )
  }
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    )
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="" breadcrumbItem="Payment Methods" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <CardTitle className="h4">
                    <Row>
                      <Col lg={6} md={12} sm={12}>
                        <Button
                         disabled={!CheckPermission("paymentmethods","add")}
                          className="btn btn-success waves-effect waves-light"
                          onClick={() => {
                            props?.history?.push("/payments/add-payment-method")
                          }}
                        >
                          <FaPlus size={12} />{" "}
                          Add Payment Method
                        </Button>
                      </Col>
                      <Col lg={6} md={12} sm={12}
                        style={{ textAlign: "right" }}>
                        <div className="mb-3">
                          {/* <Label>Discount Type</Label> */}
                          <label htmlFor="cars">Status</label>

                          <select name="cars" defaultValue={sortOptions[0].value} id="cars" onChange={(e) => { setSortBy(e.target.value) }}
                            style={{ width: 80, height: 30, marginLeft: 10 }}>
                            {sortOptions?.map((item, index) => {
                              return (
                                <option key={index} value={item.value}>{item.label}</option>
                              )
                            })}
                          </select>
                        </div>
                      </Col>
                    </Row>
                  </CardTitle>

                  <div className="table-responsive">
                    <table className="table table-bordered border-primary mb-0">

                      <thead>
                        <tr>
                          <th>Image</th>
                          <th>Name</th>
                          <th>External Deeplink</th>
                          <th>Alternate URL</th>
                          <th style={{width:"7%"}}>Type</th>
                          <th style={{width:"7%"}}>Position</th>
                          <th style={{width:"7%"}}>Status</th>
                          <th style={{width:"7%"}}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, index) => {
                          if (sortBy == "enabled") {
                            if (item?.item_status !== "Y") {
                              return
                            }
                          }
                          return (

                            <tr key={index}>
                              <th scope="row">
                                <img
                                  src={item?.image_url}
                                  style={{ width: 60 }}
                                  alt=""
                                />
                              </th>
                              <td>{item?.payment_method_name}</td>
                              <td>{item?.external_link}</td>
                              <td>{item?.alternate_url}</td>
                              <td>{item?.method_type}</td>
                              <td>{item?.sort_order}</td>
                              <td>
                                {item?.item_status == "Y" ?
                                  <Button color="success" className="btn-soft-success waves-effect waves-light">Enabled</Button>
                                  :
                                  <Button color="danger" className="btn-soft-danger waves-effect waves-light">Disabled</Button>
                                }
                              </td>
                              <td>
                                <Row className="">
                                  <div className="d-flex justify-content-center">
                                  {CheckPermission("paymentmethods","update")&&<div style={{ width: 30 }} className=" text-primary"
                                    onClick={() => {
                                      props?.history?.push("/payments/add-payment-method", {  edit: true, item: item })
                                    }}>
                                    <a className="font-size-18"
                                      onClick={() => {
                                        props?.history?.push("/payments/add-payment-method", { edit: true, item: item })
                                      }}
                                    ><FaPen /></a></div>}
                                  {success_msg ? (
                                    renderSuccessAlert()
                                  )
                                    :
                                    null
                                  }
                                  {errorMsgAlert ? (
                                    renderFailureAlert()
                                  )
                                    :
                                    null
                                  }
                                  {/* deleteEntry(item?.item_id, token)} */}
                                  {CheckPermission("paymentmethods","delete") && <div style={{ width: 30, textAlign:"center" }} >
                                    <Link to="#" className="px-3 text-danger" >
                                      <i className=" font-size-18 " onClick={() => {
                                        setItemForDelete(item)
                                        setDelete(true)
                                      }}><FaRegTrashAlt /></i>
                                    </Link>
                                  </div>}
                                  </div>
                                </Row>
                              </td>
                              
                            </tr>


                          )
                        })

                        }
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {del ? handleConfirmation() : null}

      </div>
    </React.Fragment>
  )
}

export default Payments